import { render, staticRenderFns } from "./bannerDetail.vue?vue&type=template&id=fcac1924&scoped=true&"
import script from "./bannerDetail.vue?vue&type=script&lang=js&"
export * from "./bannerDetail.vue?vue&type=script&lang=js&"
import style0 from "./bannerDetail.vue?vue&type=style&index=0&id=fcac1924&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcac1924",
  null
  
)

export default component.exports